module.exports = __webpack_public_path__ + "ddefd545ad52791ea85ed5869a044814.svg";